<template>
  <div class="d-flex align-items-center">
      <img
        v-if="team.logo || crest?.md"
        :src="team.logo ?? crest?.md"
        :alt="team.name"
        width="36"
        height="36"
        loading="eager"
        class="rounded-circle border mr-2"
        style="object-fit: cover; width: 36px; height: 36px;"
      >
      <router-link :to="{name: 'schedules.teams.show', params: { schedule: scheduleUuid, team: team.uuid }}">
        {{ team.name }}
      </router-link>
  </div>
</template>

<script>
export default {
  props: {
    scheduleUuid: { type: String, default: null },
    team: { type: Object, default: null }
  },
  computed: {
    settings () {
      return this.$store.state.settings
    },
    crest () {
      return this.settings.crest?.lg
        ? this.settings.crest
        : this.settings.logo
    },
    logo () {
      return this.settings.logo?.lg
        ? this.settings.logo
        : this.settings.crest
    }
  }
}
</script>
